import { render, staticRenderFns } from "./contentInfoDetail.vue?vue&type=template&id=3d5ee25a&scoped=true"
import script from "./contentInfoDetail.vue?vue&type=script&lang=js"
export * from "./contentInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./contentInfoDetail.vue?vue&type=style&index=0&id=3d5ee25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ee25a",
  null
  
)

export default component.exports